
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pujcovny-lyzarske-vystroje",
      function () {
        return require("private-next-pages/[region]/[resort]/pujcovny-lyzarske-vystroje.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pujcovny-lyzarske-vystroje"])
      });
    }
  